import { Navigate, useParams } from "react-router-dom";
import PlgIcon from "plg/shell/PlgIcon";
import { UNLOCKS, isUnlockKey } from "plg/screens/Unlocks/unlocks";
import { HIRE_ROUTES } from "plg/routes";
import "plg/screens/Home/PlgHome.scss";

/** Team, payroll, time-off, holidays, performance and billing before the first hire (prototype renderUnlock): what the
 * page will hold, each line with its own icon. */
function UnlockPage() {
  const { feature } = useParams<{ feature: string }>();
  if (!isUnlockKey(feature)) return <Navigate to={HIRE_ROUTES.home} replace />;
  const z = UNLOCKS[feature];
  return (
    <div className="plg-pg">
      <div className="plg-pg__col">
        <section className="zs">
          <div className="plg-ic-tile">
            <PlgIcon name={z.icon} />
          </div>
          <h1>{z.title}</h1>
          <p>{z.line}</p>
          <ul className="zs-list">
            {z.see.map(([x, icon]) => (
              <li key={x}>
                <PlgIcon name={icon} />
                {x}
              </li>
            ))}
          </ul>
          <div className="zs-quiet">{z.quiet || "This fills up once you hire someone."}</div>
        </section>
      </div>
    </div>
  );
}

export default UnlockPage;
